@if (!loadingService.loadingTopics() && paramsService.topicsBySubject()) {
<div
	class="menu-container"
	[ngClass]="{
		opened: !menuService.mainMenuClosed()
	}"
	@containerAnimation
>
	@if (mobileService.mobileView()) {
	<button class="btn-close" (click)="closeMainMenu()">
		<ng-icon class="icon-cross" [svg]="icons['close']" />
	</button>
	}

	<div class="menu-content">
		@if (menuService.currentSection() === 'chat') {
		<p-button class="chat-button" [outlined]="true" (onClick)="openNewChat()" @sectionAnimation>
			<span class="content text-left text-overflow-ellipsis">
				<i class="unir-icon-plus icon"></i>{{ 'MENU.NEW_CHAT' | translate }}
			</span>
		</p-button>
		@if (menuService.chatList()?.chats?.length) {
		<h3 class="chats-title" @sectionAnimation>{{ 'MENU.RECENT_CHATS' | translate }}</h3>
		<div #scrollContainer (scroll)="onResize()" class="chats-list overflow-scroll-gradient__scroller">
			<div class="list" @sectionAnimation>
				@if (menuService.chatList()?.chats?.length) {

				<div class="chats">
					@for (chat of menuService.chatList()?.chats; track chat.chatId) {
					<unir-ai-chat-card
						(deleteChat)="removeChat($event)"
						(chatSelected)="openChat($event)"
						(newName)="renameChat($event)"
						[chat]="chat"
						[currentChatId]="this.paramsService.chatId()!"
					></unir-ai-chat-card>
					}
				</div>
				}
			</div>
		</div>
		} } @else if (menuService.paths() && menuService.currentSection() === 'training') {
		<h3 class="chats-title" @sectionAnimation>{{ 'MENU.WEEKLY_TRAININGS' | translate }}</h3>
		<div #scrollContainer (scroll)="onResize()" class="chats-list overflow-scroll-gradient__scroller">
			<div class="list" @sectionAnimation>
				<div class="chats">
					<div class="total-progress-container">
						<ng-icon class="icon-trophy" [svg]="icons['trophy']"></ng-icon>
						<div class="total-progress">
							<div class="total-progress-score">
								<span>{{ 'MENU.SCORE_PROGRESS' | translate : { score: menuService.paths()!.score } }}</span>
								<span class="total-progress-score-percent">{{
									'MENU.GLOBAL_PROGRESS'
										| translate : { progressPercentage: floor(menuService.paths()!.progressPercentage) }
								}}</span>
							</div>
							<div class="total-progress-bar">
								<div [style.width]="floor(menuService.paths()!.progressPercentage!) + '%'"></div>
							</div>
						</div>
					</div>
					<div class="weeks-progress-container">
						@for (week of menuService.paths()!.weeks; track week.id) {
						<div class="week-container">
							<div class="week-container__progress">
								<unir-ai-progress-route
									[variant]="'continuous'"
									[progress]="week.progressPercentage"
									[size]="1.5"
									[trackColor]="
										week.weekPosition !== -1 || week.progressPercentage === 100
											? 'var(--progress-route-track)'
											: 'var(--progress-route-track-past)'
									"
									[progressColor]="
										week.weekPosition !== -1 || week.progressPercentage === 100
											? 'var(--progress-route-fill)'
											: 'var(--progress-route-fill-past)'
									"
									[checkColor]="'var(--progress-check-color)'"
								></unir-ai-progress-route>
							</div>
							<div
								class="week-container__range"
								[ngClass]="{ current: week.id === menuService.currentPathId() }"
								(click)="clickWeek(week.id)"
							>
								<h4 class="week-title">{{ 'MENU.WEEK' | translate }} {{ week.weekNumber }}</h4>
								<span class="week-range">{{ week.dateRange }}</span>
							</div>
						</div>

						}
					</div>
				</div>
			</div>
		</div>
		}
	</div>
	<div class="logo-container">
		<img
			class="unir-icon"
			[ngClass]="{ filter: dataUNI[spaConfig()?.universityCode || 'UNIR_ES'].filterInvert }"
			src="../../../../assets/img/{{ dataUNI[spaConfig()?.universityCode || 'UNIR_ES'].LogoImage }}"
			[alt]="dataUNI[spaConfig()?.universityCode || 'UNIR_ES'].name"
		/>
	</div>
</div>

<div
	class="menu-top"
	[ngClass]="{
		closed: menuService.mainMenuClosed()
	}"
	@containerAnimation
>
	<div class="menu-top__buttons">
		<button
			class="button-top"
			(click)="openMainMenu()"
			[title]="!menuService.mainMenuClosed() ? ('MENU.CLOSE_MENU' | translate) : ('MENU.OPEN_MENU' | translate)"
		>
			<ng-icon class="icon-menu-top-button" [svg]="icons['sidebar']" />
			@if( this.mobileService.mobileView() ) {
			<span>{{ 'MENU.MENU' | translate }}</span>
			}
		</button>
		<h2 class="subject-title">{{ paramsService.topicsBySubject()?.subjectName }}</h2>
		<button
			class="button-top"
			[ngClass]="{
				opened: menuService.showTheme()
			}"
			(click)="clickThemeHeader()"
			[title]="
				menuService.showTheme() ? ('MENU.CLOSE_THEME_BUTTON' | translate) : ('MENU.SEE_THEME_BUTTON' | translate)
			"
		>
			<ng-icon class="icon-menu-top-button" [svg]="icons[menuService.showTheme() ? 'book' : 'topics']" />
			@if( this.mobileService.mobileView() ) {
			<span>{{
				!menuService.showTheme() ? ('MENU.SEE_THEME_BUTTON' | translate) : ('MENU.CLOSE_THEME_BUTTON' | translate)
			}}</span>
			}
		</button>
	</div>
</div>
}

<div
	class="menu-app"
	[ngClass]="{
		opened: !menuService.mainMenuClosed()
	}"
>
	<button class="menu-home" (click)="goHome()">
		<img src="../../../../assets/img/logo-ia-unir.svg" class="logo" width="32" height="32" />
	</button>

	<div class="menu-app__buttons">
		<div class="menu-app__buttons--sections">
			@if (menuService.currentSection()) { @if (menuService.paths()) {
			<button
				class="menu-button"
				[disabled]="menuService.currentSection() === 'training'"
				(click)="goRouteSection()"
				@containerAnimation
			>
				<ng-icon class="icon-menu-app-button" [svg]="icons['routes']" />
				<span>{{ 'MENU.MY_ROUTE' | translate }}</span>
			</button>
			}
			<button
				class="menu-button"
				[disabled]="menuService.currentSection() === 'chat'"
				(click)="goChatSection()"
				@containerAnimation
			>
				<ng-icon class="icon-menu-app-button" [svg]="icons['chats']" />
				<span>{{ 'MENU.CHAT' | translate }}</span>
			</button>
			}
		</div>
		<button class="menu-button" (click)="showUserPreferences.set(!showUserPreferences())">
			<ng-icon class="icon-menu-app-button" [svg]="icons['settings']" />
			<span>{{ 'MENU.PROFILE' | translate }}</span>
		</button>
	</div>
</div>

@if (showUserPreferences()) {
<unir-ai-user-preferences (closeUserPreferences)="showUserPreferences.set(false)"></unir-ai-user-preferences>
}
